const digest = 'c8ae6f6da2812c70effd7da113ee64d35071a60ec63e6f69f01c8c61f68e9392';
const css = `@media (max-width:567px){._variantSearchRow_1h0s5_2{background-color:#f4f4f4;padding-bottom:15rem}}._searchBtnWrapper_1h0s5_8{background-color:#f4f4f4;bottom:0;left:0;padding:1rem;position:fixed;width:100%;z-index:1}._searchBtnWrapper_1h0s5_8 button{min-width:102px}@media screen and (min-width:568px){._searchBtnWrapper_1h0s5_8{align-self:flex-start;background-color:transparent;border:0;padding:33px 0 0 1rem;position:static;width:auto;z-index:auto}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'variantSearchRow': '_variantSearchRow_1h0s5_2', 'searchBtnWrapper': '_searchBtnWrapper_1h0s5_8' };
export const variantSearchRow = '_variantSearchRow_1h0s5_2';
export const searchBtnWrapper = '_searchBtnWrapper_1h0s5_8';
export { css, digest };